import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import LoadingButton from '@mui/lab/LoadingButton';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import {
    Autocomplete,
    Box,
    Checkbox,
    CircularProgress,
    Collapse,
    FormControlLabel,
    FormGroup,
    Grid,
    Modal,
    Stack,
    styled,
    TextField,
    Typography,
} from '@mui/material';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import axios from 'axios';
import { compareDesc, format, subYears } from 'date-fns';
import jwt_decode from 'jwt-decode';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import UserDefault from '../assets/user_default.png';
import InputImageModal from '../components/BasicComponents/InputImageModal';
import MobileEntry from '../components/BasicComponents/MobileEntry';
import LocationSearchInput from '../components/GoogleAutoComplete';
import Loading from '../components/Loading';
import Title from '../components/Navbar/Title';
import SimpleSnackbar from '../components/SnackBar/SimpleSnackbar';
import sendNotification from '../utils/sendNotification';
import theme from '../muiTheme';
import { addProfile } from '../redux/ProfileSlice';
import { storeToken } from '../redux/TokenSlice';
import titleCase from '../utils/titleCase';
import Skills from '../components/Profile/Skills';
import CertifySection from '../components/Profile/CertifySection';

const re = new RegExp('^0{1}4{1}([0-9]{2})\\s?([0-9]{3})\\s?([0-9]{3})$');
const reUUID = new RegExp('^[0-9a-f]{6}$');

const TextItem = styled(TextField)(({ theme }) => ({
    margin: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
        width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
        width: '70%',
    },
}));

const AutoSuggest = styled(Autocomplete)(({ theme }) => ({
    paddingRight: theme.spacing(0.5),
    paddingLeft: theme.spacing(0.5),
    [theme.breakpoints.down('md')]: {
        width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
        width: '70%',
    },
}));

const GridItem = styled(Grid)(({ theme }) => ({
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    alignSelf: 'start',
    [theme.breakpoints.down('md')]: {
        width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
        width: '70%',
    },
}));

const SchoolImage = styled('img')(({ theme }) => ({
    'max-width': '30px',
    height: 'auto',
    'border-radius': '20%',
    marginRight: '8px',
}));

const SmallSchoolImage = styled('img')(({ theme }) => ({
    width: '75px',
    height: 'auto',
    'border-radius': '10%',
}));

const Image = styled('img')(({ theme }) => ({
    width: '100%',
    'max-width': '300px',
    height: 'auto',
    'border-radius': '20%',
    'box-shadow': '0 0 25px 0 #b3bac7',
}));

const BookingButton = styled(LoadingButton)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const SetUpProfile = props => {
    const { getAccessTokenSilently, user } = useAuth0();
    const dispatch = useDispatch();

    let query = useQuery();

    const firstNameLocation = useRef();
    const lastNameLocation = useRef();
    const phoneLocation = useRef();
    const addressLocation = useRef();
    const dateOfBirthLocation = useRef();
    const imageLocation = useRef();
    const submitLocation = useRef();
    const keyLocation = useRef();
    const tempSchool = useSelector(state => state.tempSchool.tempSchool);
    const tempSchoolStatus = useSelector(state => state.tempSchool.status);

    const [state, setState] = useState({
        firstName: { value: '', touched: false, error: false, errorCode: '' },
        lastName: { value: '', touched: false, error: false, errorCode: '' },
        dateOfBirth: {
            value: new Date('2000-01-01T01:00:00'),
            touched: false,
            error: false,
            errorCode: '',
        },
        address: { value: '', touched: false, error: false, errorCode: '' },
        school: {
            value: { id: '' },
            touched: false,
            error: false,
            errorCode: '',
        },
        apiMessage: '',
        type: { value: '', touched: false, error: false, errorCode: '' },
        imageURL: {
            value: '',
            touched: false,
            error: false,
            errorCode: '',
        },
        phoneNumber: { value: '', touched: false, error: false, errorCode: '' },
        submitError: false,
        schools: { Message: { Data: [] } },
        uniqueCode: { value: '', touched: false, error: false, errorCode: '' },
    });
    const [schools, setSchools] = React.useState({});

    const [schoolList, setSchoolList] = useState({
        loading: false,
        text: '',
        results: [],
    });

    const [open, setOpen] = React.useState(false);
    const [imageLoading, setImageLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(0);
    const [pageLoading, setPageLoading] = useState(true);
    const [refreshToken, setRefreshToken] = useState({
        token: '',
        decoded: { exp: 0 },
    });
    const [TandC, setTandC] = useState(false);
    const [PP, setPP] = useState(false);
    const [MC, setMC] = useState(false);

    let userType = query.get('type');
    let userSchool = query.get('school');
    let userCode = query.get('code');

    useEffect(() => {
        async function getPage() {
            console.log('userType', userType);
            console.log('userSchool', userSchool, typeof userSchool);
            console.log('userCode', userCode);
            setPageLoading(true);
            if (props.profile.Data.Count === 0) {
                if (userType !== null) {
                    if (userType === 'school') {
                        if (tempSchoolStatus === 'succeeded') {
                            setState({
                                ...state,
                                type: {
                                    value: 'School',
                                    touched: true,
                                    error: false,
                                    errorCode: '',
                                },
                                school: {
                                    value: {
                                        'name': tempSchool.Data.Items
                                            .displayName,
                                        'id': tempSchool.Data.Items.pk1,
                                        'lat': tempSchool.Data.Items.lat,
                                        'lng': tempSchool.Data.Items.lng,
                                    },
                                    touched: true,
                                    error: false,
                                    errorCode: '',
                                },
                            });
                            setSchools(tempSchool.Data.Items);
                            setPageNumber(2);
                        } else if (userSchool !== null) {
                            const school = await getDirectSchool(userSchool);
                            console.log('schoolResult', school);

                            setState({
                                ...state,
                                type: {
                                    value: 'School',
                                    touched: true,
                                    error: false,
                                    errorCode: '',
                                },
                                school: {
                                    value: {
                                        'name': school.data.schools.Message
                                            .Data[0].displayName,
                                        'id': school.data.schools.Message
                                            .Data[0].pk1,
                                        'lat': school.data.schools.Message
                                            .Data[0].lat,
                                        'lng': school.data.schools.Message
                                            .Data[0].lng,
                                    },
                                    touched: true,
                                    error: false,
                                    errorCode: '',
                                },
                                schools: {
                                    value: {
                                        'name': school.data.schools.Message
                                            .Data[0].displayName,
                                        'id': school.data.schools.Message
                                            .Data[0].pk1,
                                        'lat': school.data.schools.Message
                                            .Data[0].lat,
                                        'lng': school.data.schools.Message
                                            .Data[0].lng,
                                    },
                                    touched: true,
                                    error: false,
                                    errorCode: '',
                                },
                            });

                            setSchools({
                                schoolLogo:
                                    school.data.schools.Message.Data[0]
                                        .schoolLogo,
                                displayName:
                                    school.data.schools.Message.Data[0]
                                        .displayName,
                                searchName:
                                    school.data.schools.Message.Data[0]
                                        .searchName,
                            });
                            setPageNumber(2);
                        } else {
                            setState({
                                ...state,
                                type: {
                                    value: 'School',
                                    touched: true,
                                    error: false,
                                    errorCode: '',
                                },
                            });
                            setPageNumber(1);
                        }
                    } else if (userType === 'teacher') {
                        setState({
                            ...state,
                            type: {
                                value: 'Teacher',
                                touched: true,
                                error: false,
                                errorCode: '',
                            },
                        });
                        setPageNumber(2);
                    }
                } else if (tempSchoolStatus === 'succeeded') {
                    setState({
                        ...state,
                        type: {
                            value: 'School',
                            touched: true,
                            error: false,
                            errorCode: '',
                        },
                        school: {
                            value: {
                                'name': tempSchool.Data.Items.displayName,
                                'id': tempSchool.Data.Items.pk1,
                                'lat': tempSchool.Data.Items.lat,
                                'lng': tempSchool.Data.Items.lng,
                            },
                            touched: true,
                            error: false,
                            errorCode: '',
                        },
                    });
                    setSchools(tempSchool.Data.Items);
                    setPageNumber(2);
                }
            } else if (
                props.profile.Data.Items[0].skills?.length > 0 &&
                props.profile.Data.Items[0].grades?.length > 0
            ) {
                setPageNumber(4);
            } else {
                setPageNumber(3);
            }
            setPageLoading(false);
        }
        getPage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.profile, tempSchoolStatus]);

    const getDirectSchool = async pk1 => {
        const token = await getAccessTokenSilently({
            scope: process.env.REACT_APP_scope,
        });
        const schoolListItems = axios.get('/getSchoolList', {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            timeout: 30000,
            headers: {
                authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            params: {
                'search': pk1,
                'exact': true,
            },
        });
        return schoolListItems;
    };

    const getSchoolList = (v, token) => {
        const schoolListItems = axios.get('/getSchoolList', {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            timeout: 30000,
            headers: {
                authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            params: {
                'search': v,
            },
        });
        return schoolListItems;
    };
    const searchAPIDebounced = AwesomeDebouncePromise(getSchoolList, 1200);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    function isValidDate(d) {
        return d instanceof Date && !isNaN(d);
    }

    const handleDOBChange = newValue => {
        let dob = state.dateOfBirth;
        if (
            compareDesc(subYears(Date.now(), 18), new Date(newValue)) === 1 ||
            !isValidDate(newValue)
        ) {
            dob.error = true;
        } else {
            dob.error = false;
        }
        console.log(
            'handleDOBChange',
            '---' + newValue + '---',
            compareDesc(subYears(Date.now(), 18), new Date(newValue)) === 1,
            !isValidDate(newValue)
        );
        dob.value = newValue;
        dob.touched = true;
        setState({
            ...state,
            dateOfBirth: dob,
        });
    };

    const handleDOBExit = event => {
        let dob = state.dateOfBirth;
        if (
            state.dateOfBirth.value === 'Invalid Date' ||
            state.dateOfBirth.value === null
        ) {
            dob.error = true;
            setState({
                ...state,
                dateOfBirth: dob,
            });
        }
    };

    const handleSelect = addressResult => {
        let addressObject = state.address;
        addressObject.value = {
            address: addressResult.address,
            LatLng: addressResult.LatLng,
        };
        addressObject.touched = true;
        addressObject.error = false;
        setState({
            ...state,
            address: addressObject,
        });
    };

    let callback = imageURL => {
        setImageLoading(true);
        //setImageURL(imageURL)
        var itemStruct = {
            value: imageURL,
            touched: true,
            error: false,
            errorCode: '',
        };
        setTimeout(() => {
            setState({
                ...state,
                imageURL: itemStruct,
            });
            setImageLoading(false);
        }, 2000);
        handleClose();
    };

    const handleLocationChange = () => {
        var interim = state.address;
        interim.touched = true;
        setState({
            ...state,
            address: interim,
        });
    };

    const updateField = event => {
        const { id, value } = event.target;
        var itemStruct = {
            value: value,
            touched: true,
            error: state.error,
            errorCode: state.errorCode,
        };
        console.log(event.target);
        setState({
            ...state,
            [id]: itemStruct,
        });
    };

    // const updateKey = event => {
    //     const { id, value } = event.target;
    //     const getState = uniqueCode;
    //     var itemStruct = {
    //         value: value,
    //         touched: true,
    //         error: state.error,
    //         errorCode: state.errorCode,
    //     };
    //     console.log(event.target.value);
    //     setuniqueCode(itemStruct);
    // };

    const handleSchoolListSearch = async (e, v) => {
        if (
            v.length > 3 &&
            schoolList.results.findIndex(sch => sch.displayName === v) === -1
        ) {
            setSchoolList({ loading: true, text: v, results: [] });

            if (Date.now() >= refreshToken.decoded.exp * 1000) {
                const token = await getAccessTokenSilently({
                    scope: process.env.REACT_APP_scope,
                });
                setRefreshToken({ token: token, decoded: jwt_decode(token) });
                const result = await searchAPIDebounced(v, token);
                console.log('My Results', result);
                setSchoolList({
                    loading: false,
                    text: v,
                    results: result.data.schools.Message.Data,
                });
            } else {
                const result = await searchAPIDebounced(v, refreshToken.token);
                console.log('My Results', result);
                setSchoolList({
                    loading: false,
                    text: v,
                    results: result.data.schools.Message.Data,
                });
            }
        } else if (v.length === 0) {
            setSchools({});
        }
    };

    const selectSchool = (e, v) => {
        if (v !== null) {
            const sel = schoolList.results.find(sch => sch.pk1 === v.pk1);
            setSchools(sel);
            setState({
                ...state,
                school: {
                    value: {
                        'name': sel.displayName,
                        'id': sel.pk1,
                        'lat': sel.lat,
                        'lng': sel.lng,
                    },
                    touched: true,
                    error: false,
                    errorCode: '',
                },
            });
        }
    };

    const exitField = event => {
        const { id, value } = event.target;
        // save field values
        console.log(value);
        var itemStruct = {
            value: state[id].value,
            touched: true,
            error: false,
            errorCode: '',
        };
        if (state[id].value === '') {
            itemStruct.error = true;
            itemStruct.errorCode = 'Please input your ' + titleCase(id);
        }
        setState({
            ...state,
            [id]: itemStruct,
        });
    };

    function phoneError(value) {
        var interimState = state.phoneNumber;
        interimState.error = value;
        setState({
            ...state,
            phoneNumber: interimState,
        });
    }

    function phoneValue(value) {
        var interimState = state.phoneNumber;
        interimState.value = value;
        setState({
            ...state,
            phoneNumber: interimState,
        });
    }

    function phoneTouched(value) {
        var interimState = state.phoneNumber;
        interimState.touched = value;
        setState({
            ...state,
            phoneNumber: interimState,
        });
    }

    const changePP = e => {
        setPP(e.target.checked);
    };

    const changeMC = e => {
        setMC(e.target.checked);
    };

    const changeTandC = e => {
        setTandC(e.target.checked);
    };

    const createUserProfile = async type => {
        try {
            if (loading) return; // avoid double click
            setLoading(true);
            async function update() {
                let imageRef = state.imageURL.value;
                console.log('imageURL is changed from the upload');

                let token = await getAccessTokenSilently({
                    scope: process.env.REACT_APP_scope,
                });
                let unformattedPhone = state.phoneNumber.value
                    .replace(/\s/g, '')
                    .replace('+61', '0');
                let formattedDOB = format(
                    state.dateOfBirth.value,
                    'yyyy-MM-dd'
                );
                let createUser;
                console.log('person type', type);
                if (type === 'Teacher') {
                    createUser = await dispatch(
                        addProfile({
                            token: token,
                            request: {
                                id: user.id,
                                firstName: state.firstName.value,
                                lastName: state.lastName.value,
                                email: user.email,
                                dateOfBirth: formattedDOB,
                                address: state.address.value.address,
                                type: type,
                                profileImage: imageRef,
                                lat: state.address.value.LatLng.lat,
                                lng: state.address.value.LatLng.lng,
                                phoneNumber: unformattedPhone,
                                invitation: userCode,
                                key: state.uniqueCode.value,
                                marketingConsent: MC,
                            },
                        })
                    );
                } else if (type === 'School') {
                    createUser = await dispatch(
                        addProfile({
                            token: token,
                            request: {
                                id: user.id,
                                firstName: state.firstName.value,
                                lastName: state.lastName.value,
                                email: user.email,
                                dateOfBirth: formattedDOB,
                                address: state.address.value.address,
                                type: type,
                                school: {
                                    'school': state.school.value.name,
                                    'schoolId': state.school.value.id,
                                    'lat': state.school.value.lat,
                                    'lng': state.school.value.lng,
                                },
                                profileImage: imageRef,
                                lat: state.address.value.LatLng.lat,
                                lng: state.address.value.LatLng.lng,
                                phoneNumber: unformattedPhone,
                                invitation: userCode,
                                key: state.uniqueCode.value,
                                marketingConsent: MC,
                            },
                        })
                    );
                }
                console.log('createUser', createUser);
                if (createUser.error !== undefined) {
                    setLoading(false);
                    setState({
                        ...state,
                        apiMessage: 'Error occurred creating profile',
                        submitError: true,
                        apiSeverity: 'error',
                    });

                    setTimeout(
                        setState({
                            ...state,
                            submitError: false,
                        }),
                        3000
                    );
                }
            }
            update();
        } catch (err) {
            console.log('Error occurred creating profile');
            setState({
                ...state,
                apiMessage: 'Error occurred creating profile',
                apiSeverity: 'error',
                submitError: true,
            });
            setLoading(false);
            setTimeout(
                setState({
                    ...state,
                    submitError: false,
                }),
                3000
            );
        }
    };

    function findError() {
        var errorFound = false;
        var addressError = { error: false, errorText: '' };
        var firstNameError = { error: false, errorText: '' };
        var lastNameError = { error: false, errorText: '' };
        var dateError = { error: false, errorText: '' };
        var phoneError = { error: false, errorText: '' };
        var imageError = { error: false, errorText: '' };
        var uniqueCodeError = { error: false, errorText: '' };
        if (state.address.value === '') {
            addressError.error = true;
            addressError.errorText = 'Enter your address';
            errorFound = true;
        }
        if (state.firstName.value === '') {
            firstNameError.error = true;
            firstNameError.errorText = 'Enter your first name';
            errorFound = true;
        }
        if (state.lastName.value === '') {
            lastNameError.error = true;
            lastNameError.errorText = 'Enter your last name';
            errorFound = true;
        }

        if (
            state.phoneNumber.touched === false ||
            !re.test(state.phoneNumber.value)
        ) {
            // Error Codes are handled in MobileEntry Component
            phoneError.error = true;
            errorFound = true;
        }
        if (state.dateOfBirth.touched === false) {
            dateError.error = true;
            dateError.errorText = 'Enter your date of birth';
            errorFound = true;
        } else if (state.dateOfBirth.error === true) {
            dateError.error = true;
            dateError.errorText = 'Date invalid or your are not over 18';
            errorFound = true;
        }
        if (state.imageURL.value === '') {
            imageError.error = true;
            imageError.errorText = 'Upload an image to your profile';
            errorFound = true;
        }
        if (TandC !== true || PP !== true) {
            errorFound = true;
        }
        if (userCode !== null) {
            if (
                state.uniqueCode.value === '' ||
                !reUUID.test(state.uniqueCode.value)
            ) {
                uniqueCodeError.error = true;
                uniqueCodeError.errorText =
                    'Input a valid Email Code. Check your email address for this code.';
                errorFound = true;
            }
        }
        if (firstNameError.error) {
            firstNameLocation.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest',
            });
        } else if (lastNameError.error) {
            lastNameLocation.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest',
            });
        } else if (phoneError.error) {
            phoneLocation.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest',
            });
        } else if (addressError.error) {
            addressLocation.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest',
            });
        } else if (dateError.error) {
            dateOfBirthLocation.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest',
            });
        } else if (imageError.error) {
            imageLocation.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest',
            });
        } else if (uniqueCodeError.error) {
            keyLocation.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest',
            });
        }
        // else {
        //     submitLocation.current.scrollIntoView({
        //         behavior: 'smooth',
        //         block: 'center',
        //         inline: 'nearest',
        //     });
        // }
        setState({
            ...state,
            address: {
                value: state.address.value,
                touched: state.address.touched,
                error: addressError.error,
                errorCode: addressError.errorText,
            },
            dateOfBirth: {
                value: state.dateOfBirth.value,
                touched: state.dateOfBirth.touched,
                error: dateError.error,
                errorCode: dateError.errorText,
            },
            firstName: {
                value: state.firstName.value,
                touched: state.firstName.touched,
                error: firstNameError.error,
                errorCode: firstNameError.errorText,
            },
            lastName: {
                value: state.lastName.value,
                touched: state.lastName.touched,
                error: lastNameError.error,
                errorCode: lastNameError.errorText,
            },
            phoneNumber: {
                value: state.phoneNumber.value,
                touched: state.phoneNumber.touched,
                error: phoneError.error,
                errorCode: phoneError.errorText,
            },
            imageURL: {
                value: state.imageURL.value,
                touched: state.imageURL.touched,
                error: imageError.error,
                errorCode: imageError.errorText,
            },
            uniqueCode: {
                value: state.uniqueCode.value,
                touched: state.uniqueCode.touched,
                error: uniqueCodeError.error,
                errorCode: uniqueCodeError.errorText,
            },
        });
        return errorFound;
    }

    async function handleSubmit(type) {
        if (type === 'School' && state.school.value.id === '') {
            setState({
                ...state,
                school: {
                    value: state.school.value,
                    touched: state.school.touched,
                    error: true,
                    errorCode: 'Please select a school',
                },
            });
        }
        createUserProfile(type);
    }

    /**
     * @function handleNext
     * @param {int} num page number to go to
     * @return {void} Nothing
     */
    async function handleNext(num, usertype) {
        if (typeof usertype !== 'undefined') {
            setState({
                ...state,
                type: {
                    value: usertype,
                    touched: true,
                    error: false,
                    errorCode: '',
                },
            });
        }

        if (num === 3) {
            const errorFound = findError();
            if (errorFound === false) {
                handleSubmit(state.type.value);
            }
        } else {
            setPageNumber(num);
        }
    }

    /**
     * @function handlePrev
     * @return {void} Nothing
     */
    async function handlePrev() {
        var currentPageNumber = pageNumber - 1;
        setPageNumber(currentPageNumber);
    }

    let content = (
        <Box>
            <Collapse in={pageNumber === 0}>
                <Typography
                    variant="h4"
                    sx={{ margin: '16px', textAlign: 'center' }}
                >
                    Are you looking for work as a substitute teacher?
                </Typography>
                <Box sx={{ textAlign: 'center' }}>
                    <BookingButton
                        sx={{ margin: '8px' }}
                        id="setTeacherTrue"
                        data-cy="yes"
                        size="large"
                        color="primary"
                        onClick={() => {
                            handleNext(2, 'Teacher');
                        }}
                        loading={loading}
                        loadingPosition="end"
                        startIcon={<ThumbUpIcon />}
                        variant="outlined"
                    >
                        Yes
                    </BookingButton>
                    <BookingButton
                        sx={{ margin: '8px' }}
                        id="setTeacherFalse"
                        data-cy="no"
                        size="large"
                        color="primary"
                        onClick={() => {
                            handleNext(1, 'School');
                        }}
                        disabled={loading}
                        startIcon={<ThumbDownIcon />}
                        variant="outlined"
                    >
                        No
                    </BookingButton>
                </Box>
            </Collapse>

            <Collapse in={pageNumber === 1}>
                <Box sx={{ textAlign: 'center', marginBottom: '40px' }}>
                    {tempSchoolStatus === 'succeeded' ? (
                        <>
                            <Image
                                src={tempSchool.Data.Items.schoolLogo}
                                sx={{ margin: '20px' }}
                            ></Image>
                            <Typography variant="h4">
                                {tempSchool.Data.Items.displayName}
                            </Typography>
                        </>
                    ) : (
                        <>
                            <Typography variant="h4">
                                Type the name of the school where you work
                            </Typography>
                            <Box
                                sx={{
                                    justifyContent: 'center',
                                    display: 'flex',
                                }}
                            >
                                <AutoSuggest
                                    id="school-search"
                                    data-cy="school-search"
                                    options={schoolList.results}
                                    getOptionLabel={option =>
                                        typeof option === 'string'
                                            ? option
                                            : option.displayName
                                    }
                                    includeInputInList
                                    filterSelectedOptions
                                    value={schools.displayName}
                                    filterOptions={x => x}
                                    loading={schoolList.loading}
                                    onInputChange={(event, newValue) =>
                                        handleSchoolListSearch(event, newValue)
                                    }
                                    onChange={(event, newValue) =>
                                        selectSchool(event, newValue)
                                    }
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label="School"
                                            margin="normal"
                                        />
                                    )}
                                    renderOption={(
                                        props,
                                        option,
                                        { inputValue }
                                    ) => {
                                        const matches = match(
                                            option.displayName,
                                            inputValue
                                        );
                                        const parts = parse(
                                            option.displayName,
                                            matches
                                        );

                                        return (
                                            <li {...props}>
                                                <Box>
                                                    <SchoolImage
                                                        loading="lazy"
                                                        src={option.schoolLogo}
                                                    ></SchoolImage>

                                                    {parts.map(
                                                        (part, index) => (
                                                            <span
                                                                key={option.pk1}
                                                                style={{
                                                                    fontWeight:
                                                                        part.highlight
                                                                            ? 700
                                                                            : 400,
                                                                }}
                                                            >
                                                                {part.text}
                                                            </span>
                                                        )
                                                    )}
                                                </Box>
                                            </li>
                                        );
                                    }}
                                />
                            </Box>
                            <Typography variant="h6" sx={{ marginTop: '60px' }}>
                                Can't find your School?
                            </Typography>
                            <Typography variant="body">
                                <Link to="/addSchool" data-cy="new-school">
                                    Click here sign up your School.
                                </Link>
                            </Typography>
                        </>
                    )}
                </Box>

                <Box sx={{ textAlign: 'center' }}>
                    <BookingButton
                        disabled={
                            typeof state.school.value.name === 'undefined'
                        }
                        onClick={() => handleNext(2)}
                        id="submit"
                        data-cy="school-next"
                        size="large"
                        color="primary"
                        loading={loading}
                        loadingPosition="end"
                        startIcon={<ArrowForwardIosIcon />}
                        variant="outlined"
                    >
                        Next
                    </BookingButton>
                </Box>
                {(userType === null || tempSchoolStatus === 'succeeded') && (
                    <Box sx={{ textAlign: 'center' }}>
                        <BookingButton
                            onClick={() => handlePrev()}
                            id="back"
                            size="large"
                            color="primary"
                            variant="outlined"
                            disabled={loading}
                            startIcon={<ArrowBackIosIcon />}
                        >
                            Back
                        </BookingButton>
                    </Box>
                )}
            </Collapse>

            <Collapse in={pageNumber === 2}>
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    spacing={3}
                >
                    <GridItem item xs={12} md={6}>
                        {typeof schools.searchName !== 'undefined' && (
                            <Stack
                                direction="row"
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <SmallSchoolImage
                                    src={schools.schoolLogo}
                                ></SmallSchoolImage>
                                <Typography
                                    variant="h5"
                                    sx={{ marginLeft: '24px' }}
                                >{`${schools.displayName}`}</Typography>
                            </Stack>
                        )}
                        <Box
                            m={1}
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        ></Box>
                        <Box m={1}>
                            <TextItem
                                disabled
                                id="standard-disabled"
                                data-cy="email"
                                label="Email"
                                value={user.email}
                            />
                        </Box>
                        <Box m={1}>
                            <TextItem
                                ref={firstNameLocation}
                                error={state.firstName.error}
                                id="firstName"
                                data-cy="first-name"
                                label="First Name"
                                variant="outlined"
                                helperText={state.firstName.errorCode}
                                value={state.firstName.value}
                                onChange={updateField}
                                onBlur={exitField}
                            />
                        </Box>
                        <Box m={1}>
                            <TextItem
                                ref={lastNameLocation}
                                error={state.lastName.error}
                                id="lastName"
                                data-cy="last-name"
                                label="Last Name"
                                variant="outlined"
                                helperText={state.lastName.errorCode}
                                value={state.lastName.value}
                                onChange={updateField}
                                onBlur={exitField}
                            />
                        </Box>
                        <Box m={1} ref={phoneLocation}>
                            <MobileEntry
                                id="phone"
                                label="Mobile Number"
                                variant="outlined"
                                phoneNumber={state.phoneNumber.value}
                                passThroughError={state.phoneNumber.error}
                                error={phoneError}
                                touched={phoneTouched}
                                value={phoneValue}
                                sx={{
                                    margin: theme.spacing(1),
                                    width: '100%',
                                    '@media screen and (min-width: 600px)': {
                                        width: '70%',
                                    },
                                }}
                            />
                        </Box>
                        <Box m={1} ref={addressLocation}>
                            <LocationSearchInput
                                data-cy="address"
                                onChange={handleLocationChange}
                                onSelect={handleSelect}
                                error={state.address.error}
                                searchType="address"
                                sx={{
                                    margin: theme.spacing(1),
                                    width: '100%',
                                    '@media screen and (min-width: 600px)': {
                                        width: '70%',
                                    },
                                }}
                            />
                        </Box>
                        <Box m={1} data-cy="date-of-birth">
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DesktopDatePicker
                                    ref={dateOfBirthLocation}
                                    label="Date of Birth"
                                    inputFormat="dd/MM/yyyy"
                                    value={state.dateOfBirth.value}
                                    onChange={handleDOBChange}
                                    onBlur={handleDOBExit}
                                    error={true}
                                    renderInput={params => (
                                        <TextItem
                                            {...params}
                                            error={state.dateOfBirth.error}
                                        />
                                    )}
                                />
                                {state.dateOfBirth.error && (
                                    <Typography
                                        color="error"
                                        variant="subtitle2"
                                    >
                                        {state.dateOfBirth.errorCode}
                                    </Typography>
                                )}
                            </LocalizationProvider>
                            {/* <TextItem
                                error={state.dateOfBirth.error}
                                id="dateOfBirth"
                                label="Date of Birth"
                                type="date"
                                defaultValue="2003-01-01"
                                onChange={updateField}
                                helperText={state.dateOfBirth.errorCode}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            /> */}
                        </Box>
                    </GridItem>
                    <GridItem item xs={12} md={6} sx={{ margin: 'auto' }}>
                        {imageLoading ? (
                            <Box>
                                <CircularProgress color="primary" />
                            </Box>
                        ) : (
                            <Box ref={imageLocation}>
                                {state.imageURL.touched === true ? (
                                    <Image
                                        src={state.imageURL.value}
                                        onClick={handleOpen}
                                    ></Image>
                                ) : (
                                    <Box>
                                        <Image
                                            src={UserDefault}
                                            onClick={handleOpen}
                                            data-cy="profile-image"
                                            sx={
                                                state.imageURL.error && {
                                                    border: '1px red solid',
                                                    margin: '20px',
                                                }
                                            }
                                        ></Image>
                                        {state.imageURL.error === true && (
                                            <Typography color="error">
                                                Image Upload Required
                                            </Typography>
                                        )}
                                    </Box>
                                )}
                            </Box>
                        )}
                    </GridItem>
                </Grid>

                <Box
                    m={1}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    {userCode !== null && (
                        <TextItem
                            ref={keyLocation}
                            error={state.uniqueCode.error}
                            id="uniqueCode"
                            label="Unique Code"
                            data-cy="email-key"
                            variant="outlined"
                            helperText={state.uniqueCode.errorCode}
                            value={state.uniqueCode.value}
                            onChange={updateField}
                            onBlur={exitField}
                        />
                    )}
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <FormGroup>
                        <FormControlLabel
                            data-cy="terms-conditions"
                            control={
                                <Checkbox
                                    checked={TandC}
                                    onChange={changeTandC}
                                />
                            }
                            label={
                                <Typography>
                                    I have read and accept the airTeachr{' '}
                                    <a href="https://airteachr.com.au/terms-and-conditions">
                                        terms and conditions
                                    </a>
                                </Typography>
                            }
                        />
                        <FormControlLabel
                            data-cy="privacy"
                            control={
                                <Checkbox checked={PP} onChange={changePP} />
                            }
                            label={
                                <Typography>
                                    I have read and accept the airTeachr{' '}
                                    <a href="https://airteachr.com.au/privacy-policy">
                                        privacy policy
                                    </a>
                                </Typography>
                            }
                        />
                        <FormControlLabel
                            data-cy="emails"
                            control={
                                <Checkbox checked={MC} onChange={changeMC} />
                            }
                            label={
                                <Typography>
                                    I would like to receive emails about new
                                    events and offers
                                </Typography>
                            }
                        />
                    </FormGroup>
                </Box>

                <Box
                    m={1}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    {/* Show when userType is not null or there is tempSchoolStatus
                    come from page 2 - School N + N come from page 1 - Teacher N
                    + N come from invitation - School Y + N come from invitation
                    - Teacher Y + N come from page 2 - tempSchool Y + Y Dont
                    Show when userType is not null or tempSchoolStatus ===
                    'succeeded' */}
                    {userType === 'teacher' ||
                    userSchool !== null ||
                    tempSchoolStatus === 'succeeded' ? (
                        <div></div>
                    ) : (
                        <BookingButton
                            sx={{ margin: '8px' }}
                            id="back"
                            size="large"
                            color="primary"
                            onClick={() => {
                                if (state.type.value === 'Teacher') {
                                    handleNext(0);
                                } else {
                                    handleNext(1);
                                }
                            }}
                            variant="outlined"
                            disabled={loading}
                            startIcon={<ArrowBackIosIcon />}
                        >
                            Back
                        </BookingButton>
                    )}
                    <BookingButton
                        sx={{ margin: '8px' }}
                        ref={submitLocation}
                        disabled={
                            imageLoading || TandC === false || PP === false
                        }
                        loading={loading}
                        data-cy="next"
                        id="skillSave"
                        size="large"
                        color="primary"
                        onClick={() => handleNext(3)}
                        endIcon={<ArrowForwardIosIcon />}
                        variant="outlined"
                    >
                        Next
                    </BookingButton>
                </Box>
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="Modal-Profile-Image"
                    aria-describedby="Open-Modal-For-Upload"
                >
                    <InputImageModal
                        parentCallback={callback}
                        image={state.imageURL.value}
                        text="Profile Image"
                    />
                </Modal>
            </Collapse>

            <Collapse in={pageNumber === 3}>
                <Skills
                    grades={[]}
                    skills={[]}
                    otherSkills=""
                    setNotif={(severity, autoHideDuration, description) => {
                        sendNotification(
                            severity,
                            autoHideDuration,
                            description
                        );
                    }}
                    setSnackBar={(open, severity, message) => {
                        setState({
                            ...state,
                            submitError: open,
                            apiMessage: message,
                            apiSeverity: severity,
                        });
                    }}
                />
            </Collapse>

            <Collapse in={pageNumber === 4}>
                <CertifySection
                    verified={props.profile.Data.Items[0]?.verified}
                    getDocumentTypes={pageNumber === 4}
                    skillsComplete={true}
                    fullVerification={false}
                />
            </Collapse>
        </Box>
    );

    return (
        <Box>
            <Title title="Set Up Your Profile" />
            <Box
                align="center"
                justify="center"
                className="padding"
                sx={{
                    margin: '30px',
                    boxShadow: '1px 1px 9px -2px rgb(0 0 0 / 20%)',
                    backgroundColor: '#FFF',
                    paddingTop: '30px',
                }}
            >
                {pageLoading === true ? <Loading /> : content}
            </Box>
            <SimpleSnackbar
                open={state.submitError}
                message={state.apiMessage}
                severity={state.apiSeverity}
            />
        </Box>
    );
};

export default withAuthenticationRequired(SetUpProfile, {
    onRedirecting: () => <Loading />,
});
